import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from '@emotion/css';
import { ChevronLeft, ChevronRight } from 'react-feather';

const arrowBtn = (params) => css`
  background: transparent;
  outline: none;
  border: 0;
  padding: 0;
  top: 27px;
  width: 50px;
  height: 50px;
  z-index: 1000;

  & > svg {
    color: ${params?.textColor};
  }

  &.slick-disabled {
    opacity: 0.50;
  }

  &.slick-next {
    right: -14px;
  }

  &.slick-prev {
    left: -14px;
  }

  &:before {
    display: none;
    content: '';
  }
`;

const SlickArrow = ({
  onClick,
  themeConfig,
  className,
  direction,
}) => (
  <button type="button" onClick={onClick} className={cx(arrowBtn(themeConfig), className)}>
    {direction === 'next' ? <ChevronRight size={50} /> : <ChevronLeft size={50} />}
  </button>
);

SlickArrow.propTypes = {
  direction: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  themeConfig: PropTypes.object,
};

export default SlickArrow;
